import { I18nComponente } from "@/types/gerais"

export const TGestaoTravamentoi18n: I18nComponente = {
  "pt-BR": {
    selecionePrimeiroDiaDeDestravamento: "selecione o primeiro dia de destravamento do projeto que desejar",
    travarNovoPeriodo: "travar novo período"
  },
  "es-CO": {
    selecionePrimeiroDiaDeDestravamento: "seleccione el primer día de congelamiento del proyecto que desee",
    travarNovoPeriodo: "congelar nuevo período"
  },
}
